import {
  ChipField,
  Datagrid,
  DateField,
  List,
  ListProps,
  TextField,
  TextInput,
  EditButton,
  useGetList,
  DeleteWithConfirmButton,
  WithRecord,
  BooleanField,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";
export const ListPosts: React.FC<ListProps> = (props) => {
  const { data: statuses = [], isLoading: isLoadingStatuses } = useGetList("statuses");

  const filters = [
    <TextInput key="title" label="Título" source="title" alwaysOn />,
  ];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      sort={{ field: "publishedAt", order: "DESC" }}
      pagination={<StandardPagination />}
    >
      <Datagrid optimized>
        <TextField source="title" label="Título" />
        <DateField source="publishedAt" label="Fecha de publicación" />
        <ChipField source="author.fullName" label="Autor" />
        <BooleanField source="isPublished" label="Publicado" />
        <BooleanField source="isHighlighted" label="Destacado" />
        <WithRecord
          render={(record) => {
            const deleteTitle = `Eliminar publicación: ${record.title || record.id}`;
            return (
              <>
                <EditButton label="Editar" />
                <DeleteWithConfirmButton
                  mutationMode="pessimistic"
                  confirmTitle={deleteTitle}
                  confirmContent="¿Está seguro que desea eliminar esta Publicación? Esta acción no se puede deshacer."
                  record={record}
                  label="Eliminar"
                />
              </>
            );
          }}
        />
      </Datagrid>
    </List>
  );
};
